var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineTextActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2998 19.0008C4.2998 18.6142 4.61321 18.3008 4.9998 18.3008H18.9998C19.3864 18.3008 19.6998 18.6142 19.6998 19.0008C19.6998 19.3874 19.3864 19.7008 18.9998 19.7008H4.9998C4.61321 19.7008 4.2998 19.3874 4.2998 19.0008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9998 4.30078C7.3864 4.30078 7.6998 4.61418 7.6998 5.00078V10.5008C7.6998 11.7942 8.16752 13.0228 8.98223 13.919C9.79492 14.813 10.8821 15.3008 11.9998 15.3008C13.1175 15.3008 14.2047 14.813 15.0174 13.919C15.8321 13.0228 16.2998 11.7942 16.2998 10.5008V5.00078C16.2998 4.61418 16.6132 4.30078 16.9998 4.30078C17.3864 4.30078 17.6998 4.61418 17.6998 5.00078V10.5008C17.6998 12.1247 17.114 13.694 16.0533 14.8607C14.9906 16.0297 13.5342 16.7008 11.9998 16.7008C10.4654 16.7008 9.00899 16.0297 7.94631 14.8607C6.88566 13.694 6.2998 12.1247 6.2998 10.5008V5.00078C6.2998 4.61418 6.61321 4.30078 6.9998 4.30078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineTextActive);
export default __webpack_public_path__ + "static/media/underline-text-active.75418c29e45ab662031b9a37eff580b9.svg";
export { ForwardRef as ReactComponent };